<template>
  <div class="container-fluid py-4 boutique-page">

    <!-- ================= HEADER ================= -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-boutique flex-wrap">

      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-person-circle fs-2 text-success"></i>

        <div>
          <h2 class="fw-bold mb-0 text-white">Mon compte</h2>
          <small class="text-white-50">Gestion de votre profil utilisateur</small>
        </div>
      </div>

    </div>

    <!-- ================= INFO USER ================= -->
    <div class="card card-boutique shadow-sm p-4 mb-4">

      <h5 class="fw-bold text-success mb-3">
        Informations personnelles
      </h5>

      <div v-if="user">

        <div class="row mb-2">
          <div class="col-md-4 fw-semibold">Nom complet :</div>
          <div class="col-md-8">{{ user.nom }} {{ user.prenom }}</div>
        </div>

        <div class="row mb-2">
          <div class="col-md-4 fw-semibold">Email :</div>
          <div class="col-md-8">{{ user.email }}</div>
        </div>

        <div class="row mb-2">
          <div class="col-md-4 fw-semibold">Type utilisateur :</div>
          <div class="col-md-8">{{ user.typeUser || 'Non défini' }}</div>
        </div>

        <div class="row mb-2">
          <div class="col-md-4 fw-semibold">Date création :</div>
          <div class="col-md-8">
            {{ formatDate(user.createdAt?.date || user.createdAt) }}
          </div>
        </div>

      </div>

      <div v-else class="text-muted fst-italic">
        Aucune information disponible
      </div>
    </div>

    <!-- ================= PASSWORD ================= -->
    <div class="card card-boutique shadow-sm p-4">

      <h5 class="fw-bold text-success mb-3">
        Changer le mot de passe
      </h5>

      <form @submit.prevent="updatePassword">

        <div class="row g-3">

          <div class="col-md-4">
            <label class="form-label fw-bold">Mot de passe actuel</label>
            <input v-model="currentPassword"
                   type="password"
                   class="form-control form-control-boutique"
                   placeholder="********"
                   required />
          </div>

          <div class="col-md-4">
            <label class="form-label fw-bold">Nouveau mot de passe</label>
            <input v-model="newPassword"
                   type="password"
                   class="form-control form-control-boutique"
                   placeholder="********"
                   required />
          </div>

          <div class="col-md-4">
            <label class="form-label fw-bold">Confirmation</label>
            <input v-model="confirmPassword"
                   type="password"
                   class="form-control form-control-boutique"
                   placeholder="********"
                   required />
          </div>

        </div>

        <div class="mt-4 text-end">
          <button type="submit"
                  class="btn btn-success btn-lg px-4"
                  :disabled="loading">

            <span v-if="loading"
                  class="spinner-border spinner-border-sm me-2"></span>

            Mettre à jour
          </button>
        </div>

        <div v-if="message"
             class="alert mt-3"
             :class="messageType">
          {{ message }}
        </div>

      </form>

    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import dayjs from 'dayjs';
import api from '@/api';

export default {
  name: 'MonCompte',

  data() {
    return {
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
      message: '',
      messageType: 'alert-info',
      loading: false,
    };
  },

  computed: {
    ...mapGetters(['user']),
  },

  methods: {
    ...mapActions(['logout']),

    formatDate(date) {
      if (!date) return 'N/A';
      return dayjs(date).format('DD-MM-YYYY HH:mm');
    },

    async updatePassword() {
      if (this.newPassword !== this.confirmPassword) {
        this.message = "Les mots de passe ne correspondent pas.";
        this.messageType = "alert-danger";
        return;
      }

      this.loading = true;
      this.message = '';

      try {
        await api.updatePassword(this.user.id, {
          id: this.user.id,
          currentPassword: this.currentPassword,
          newPassword: this.newPassword
        });

        this.message = "Mot de passe mis à jour avec succès.";
        this.messageType = "alert-success";

        this.currentPassword =
        this.newPassword =
        this.confirmPassword = '';

      } catch (error) {
        this.message =
          error.response?.data?.detail ||
          "Une erreur est survenue.";
        this.messageType = "alert-danger";
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.boutique-page {
  background: #f5f7fb;
  min-height: 100vh;
}

/* HEADER */
.header-boutique {
  background: linear-gradient(135deg, #064e3b, #10b981);
  padding: 20px;
  border-radius: 18px;
  color: white;
}

/* CARD STYLE */
.card-boutique {
  border-radius: 18px;
  border: none;
}

/* INPUT STYLE */
.form-control-boutique {
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  padding: 10px;
}

.form-control-boutique:focus {
  border-color: #10b981;
  box-shadow: 0 0 0 0.15rem rgba(16,185,129,0.25);
}

/* BUTTON */
.btn-success {
  background: #10b981;
  border: none;
}

.btn-success:hover {
  background: #059669;
}

/* ALERT */
.alert {
  border-radius: 12px;
}
</style>